import gql from 'graphql-tag';

const GET_POLICY_SETS_ASSET_ONBOARDING = gql`
  query(
    $policySetId: ID!
    $category: PolicySetCategory!
    $clientId: ID
    $siteId: ID
    $assetId: ID
  ) {
    getPolicySet(
      policySetId: $policySetId
      category: $category
      clientId: $clientId
      siteId: $siteId
      assetId: $assetId
    ) {
      policySetId
      name
      description
      category
      parentPolicySet {
        policySetId
      }
      assetClass {
        classId
        iconClass
        supportedModules
      }
      policyAssociations {
        policyType
        policies {
          policyId
          name
          enabled
          ... on AssetClassPolicy {
            inherited
            overridden
            overriddenPolicy {
              policyId
            }
          }
        }
      }
      assetGroups {
        groupId
        name
      }
    }
  }
`;

const GET_POLICY_ASSET_ONBOARDING = gql`
  query($policyId: ID!) {
    getPolicy(policyId: $policyId) {
      policyId
      name
      enabled
      actions {
        actionConfigId
        actionType
        script {
          scriptId
          name
          custom
        }
        scriptArguments
        executionOrder
      }
      onboardingPolicyConfig {
        actionType
        executionType
        scheduleDetail
      }
    }
  }
`;

const ADD_POLICY_SET_ASSET_ONBOARDING = gql`
  mutation addPolicies(
    $policySetId: ID!
    $policyType: String!
    $policyInput: [PolicyInput!]
    $clientId: ID
    $siteId: ID
    $assetId: ID
  ) {
    addPolicies(
      policySetId: $policySetId
      policyType: $policyType
      policyInput: $policyInput
      clientId: $clientId
      siteId: $siteId
      assetId: $assetId
    ) {
      policyId
      name
      description
      enabled
      onboardingPolicyConfig {
        executionType
        actionType
        scheduleDetail
      }
      actions {
        actionConfigId
        actionType
        script {
          scriptId
          name
          custom
        }
        scriptArguments
        executionOrder
      }
    }
  }
`;

const UPDATE_POLICY_SET_ASSET_ONBOARDING = gql`
  mutation updatePolicies($policySetId: ID!, $policyInput: [PolicyInput!]) {
    updatePolicies(policySetId: $policySetId, policyInput: $policyInput) {
      policyId
      name
      description
      enabled
      onboardingPolicyConfig {
        executionType
        actionType
        scheduleDetail
      }
      actions {
        actionConfigId
        actionType
        script {
          scriptId
          name
          custom
        }
        executionOrder
        scriptArguments
      }
    }
  }
`;

const DELETE_POLICY_SET_ASSET_ONBOARDING = gql`
  mutation deletePolicy($policyId: ID!) {
    deletePolicy(policyId: $policyId)
  }
`;

const CREATE_POLICY_SET_ASSET_ONBOARDING = gql`
  mutation($input: PolicySetInput) {
    createPolicySet(input: $input) {
      policySetId
    }
  }
`;

export {
  ADD_POLICY_SET_ASSET_ONBOARDING,
  GET_POLICY_ASSET_ONBOARDING,
  GET_POLICY_SETS_ASSET_ONBOARDING,
  UPDATE_POLICY_SET_ASSET_ONBOARDING,
  DELETE_POLICY_SET_ASSET_ONBOARDING,
  CREATE_POLICY_SET_ASSET_ONBOARDING
};
